import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BiArrowBack } from 'react-icons/bi';
import { MdEdit, MdDelete } from 'react-icons/md';

const BarrelBlanketDrafts = () => {
    const navigate = useNavigate();
    const [drafts, setDrafts] = useState([]);
    const [submittingIndex, setSubmittingIndex] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        const formData = localStorage.getItem('barrelBlanketDrafts');
        if (formData) {
            const parsedData = JSON.parse(formData);
            setDrafts(parsedData.length ? parsedData.reverse() : []);
        } else {
            setDrafts([]);
        }
    };

    const editForm = (data, idx) => {
        sessionStorage.setItem('editDraftData', JSON.stringify(data));
        sessionStorage.setItem('editDraftIndex', idx.toString());
        navigate('/barrel-blanket/form');
    };

    const submitForm = async (data, idx) => {
        setSubmittingIndex(idx);
        try {
            const token = localStorage.getItem("apUserToken");

            if (!token) {
                alert('Authentication token not found. Please login again.');
                setSubmittingIndex(null);
                return;
            }

            const payload = {
                username: data.username,
                companyName: data.companyName,
                utility: data.utility,
                city: data.city,
                state: data.state,
                barrelEntries: data.barrelEntries.map(entry => ({
                    equipmentId: entry.equipmentId,
                    model: entry.model,
                    size: entry.size,
                    setpointTemp: entry.setpointTemp,
                    orientation: entry.orientation,
                    typeOfCooling: entry.typeOfCooling,
                    shrouding: entry.shrouding,
                    insulation: entry.insulation,
                    notes: entry.notes,
                    equipmentSectionsSizes: entry.equipmentSectionsSizes.map(section => ({
                        circumference: section.circumference,
                        width: section.width,
                        surfaceArea: section.surfaceArea,
                        tb: section.tb,
                        notes: section.notes
                    }))
                }))
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}barrelBlanket/create`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                alert("Form Submitted Successfully");
                let newDraft = drafts.filter((item2, idx2) => idx2 !== idx);
                setDrafts(newDraft);
                localStorage.setItem('barrelBlanketDrafts', JSON.stringify(newDraft));
            } else {
                alert("Form NOT submitted. Please try again when connected to Internet");
            }
            setSubmittingIndex(null);
        } catch (error) {
            console.error('API Error:', error);
            setSubmittingIndex(null);
            alert("Form NOT submitted. Please try again when connected to Internet");
        }
    };

    const deleteEntry = (idx) => {
        if (window.confirm('Are you sure you want to delete this draft?')) {
            let newDraft = drafts.filter((item2, idx2) => idx2 !== idx);
            setDrafts(newDraft);
            localStorage.setItem('barrelBlanketDrafts', JSON.stringify(newDraft));
        }
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex items-center gap-4">
                    <button onClick={() => navigate('/barrel-blanket')} className="text-white hover:text-gray-200">
                        <BiArrowBack size={24} />
                    </button>
                    <h1 className="text-2xl font-bold">Barrel Blanket Drafts</h1>
                </div>
            </div>

            {/* Content */}
            <div className="container mx-auto p-4 max-w-4xl">
                {drafts.length !== 0 ? (
                    <div className="space-y-4">
                        {drafts.map((item, idx) => (
                            <div key={idx} className="bg-gray-100 p-5 rounded-lg border border-gray-300">
                                <div className="flex justify-end gap-5 mb-3">
                                    <button
                                        onClick={() => editForm(item, idx)}
                                        className="text-teal-600 hover:text-teal-800"
                                    >
                                        <MdEdit size={20} />
                                    </button>
                                    <button
                                        onClick={() => deleteEntry(idx)}
                                        className="text-teal-600 hover:text-teal-800"
                                    >
                                        <MdDelete size={20} />
                                    </button>
                                </div>
                                <h3 className="text-lg font-bold text-teal-600 mb-2">
                                    {item.companyName}, {item.city}, {item.state}
                                </h3>
                                <p className="text-sm text-teal-600">User: {item.username}</p>
                                <p className="text-sm text-teal-600">Company Contact: {item.utility}</p>
                                <p className="text-xs text-teal-600">
                                    Date: {new Date(item.date).toLocaleString()}
                                </p>
                                <p className="text-xs text-teal-600">
                                    Entries: {item.barrelEntries.length}
                                </p>
                                <button
                                    onClick={() => {
                                        submittingIndex === null
                                            ? submitForm(item, idx)
                                            : alert('Submit one form at a time. One form already in process.');
                                    }}
                                    className="mt-3 w-full bg-teal-600 text-white py-2 px-4 rounded-lg hover:bg-teal-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                                    disabled={submittingIndex !== null && submittingIndex !== idx}
                                >
                                    {submittingIndex === idx ? (
                                        <span className="flex items-center justify-center gap-2">
                                            <span className="animate-spin">⏳</span>
                                            Submitting...
                                        </span>
                                    ) : (
                                        'Submit Form'
                                    )}
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex items-center justify-center h-64">
                        <p className="text-gray-600 text-lg">No drafts found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BarrelBlanketDrafts;

